/** Ссылка «в авто-арбитраж на эту связку»: новая сессия с уже выставленными
 *  парой и биржами. Формат — тот, что читает AutoSessionNew (и терминал):
 *  нативные имена ног — только если отличаются от канона (1000PEPE↔PEPE). */
export function autoSessionLink(p: {
  symbol: string; longEx: string; shortEx: string;
  longSymbol?: string | null; shortSymbol?: string | null;
}): string {
  const params = new URLSearchParams({ symbol: p.symbol, long: p.longEx, short: p.shortEx });
  // Родное имя в формате биржи (`para:TREAD` у дека HL, `PF_TREADUSD` у Kraken,
  // `BTC-USDT`) — это та же монета, просто другая запись. В форму его нести
  // нельзя: поле тикера вырезало `:`/`_`, и выходило «нет пары PARATREADUSDT».
  const differs = (s?: string | null) => !!s && s !== p.symbol && !/[:_\-]/.test(s);
  if (differs(p.shortSymbol)) params.set('short_sym', p.shortSymbol as string);
  if (differs(p.longSymbol)) params.set('long_sym', p.longSymbol as string);
  return `/auto/new?${params.toString()}`;
}
